<template>
    <div class="carousel-container">
        <div v-for="image in images" 
            :key="image.id"
            :class="['img-container', 'container-' + image.class]"
        >
            <img
            :src="image.src"
            :class="image.class"
            />
          <div class="img-caption">{{ image.caption }}</div>
        </div>
  
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        images: [
            { id: 0, src: 'figures/sample-carousel/file01.png', class: 'showing', caption: 'Shared by @hampnyc on USB Club' }, 
            { id: 1, src: 'figures/sample-carousel/file02.png', class: 'pre-show', caption: 'Shared by @devin on USB Club' },
            { id: 2, src: 'figures/sample-carousel/file03.png', class: 'pre-show', caption: 'Shared by @blot on USB Club' },
            { id: 3, src: 'figures/sample-carousel/file04.png', class: 'pre-show', caption: 'Shared by @usbnorm on USB Club' },
            { id: 4, src: 'figures/sample-carousel/file05.png', class: 'pre-show', caption: 'Shared by @elliot on USB Club' },
        ],
        currId: 0
      };
    },
    mounted() {
      this.scrollCarousel();
    },
    methods: {
      scrollCarousel() {
        setInterval(() => {
            if(this.currId == this.images.length - 1){
                this.currId = 0;
            } else {
                this.currId++;

            }
            
            for(let image of this.images){
                if(image.id === this.currId){
                    image.class = 'showing'
                } else if (image.id === (this.currId - 1) % (this.images.length)) {
                    image.class = 'post-show'
                } else if (image.id === (this.currId + 1) % (this.images.length)) {
                    image.class = 'pre-show'
                }
                if(this.currId === 0 && image.id === (this.images.length - 1)){
                    image.class = 'post-show'
                }
            }
        }, 3000);
      },
    }
  };
  </script>
  
  <style scoped>
  .carousel-container {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
  }

  .img-container {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
  }

  .img-caption {
    font-family: 'Untitled Serif', serif;
    font-style: italic;
    font-size: 18px;
    color: #909090;
    transition: 1s cubic-bezier(0.19, 1, 0.22, 1);
    transition-delay: 300ms;
  }

  .container-post-show .img-caption {
    opacity: 0;
    transition-delay: 0ms;
  }

  .container-showing .img-caption {
    opacity: 1;
  }

  .container-pre-show .img-caption {
    opacity: 0;
  }

  img {
    transition: 1s cubic-bezier(0.19, 1, 0.22, 1);
    object-position: center;
    margin: auto;
    max-height: 70vh;
    max-width: 100%;
  }
  .showing {
    opacity: 1;
    transition-delay: 200ms;
  }

  .pre-show {
  
    opacity: 0;
    transform: translate(0, 50px);
  }
  
  .post-show {
    opacity: 0;
    transform: translate(0, -50px);
  }

  @media screen and (max-width: 700px) {
    .img-caption {
        font-size: 14px;
    }
  }

  
  
  </style>
  